import React from "react";

const Footer = () => {
  return (
    <div className="w-full h-20 border-t-2 border-primary flex flex-col items-center justify-center">
      <p className="font-custom text-lg font-medium">© Usama Tahir 2021</p>
    </div>
  );
};

export default Footer;
